import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import ClientLogos from "@/components/site/ClientLogos";
import TrustIntro from "@/components/site/TrustIntro";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import AnalyticsShowcase from "@/components/site/AnalyticsShowcase";
import Testimonials from "@/components/site/Testimonials";
import BookingSection from "@/components/site/BookingSection";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import { useHashScroll } from "@/lib/navigation";

export default function LandingPage() {
  useHashScroll();
  return (
    <div data-testid="landing-page" className="bg-cream-50 text-ink-900 min-h-screen">
      <Header />
      <main>
        <Hero />
        <TrustIntro />
        <WhyChooseUs />
        <AnalyticsShowcase />
        <Testimonials />
        <ClientLogos />
        <BookingSection />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
